"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registeredDrivers = void 0;
exports.registerVideoDrivers = registerVideoDrivers;
exports.registeredDrivers = [];
function registerVideoDrivers(driver) {
    exports.registeredDrivers.push(driver);
}
//# sourceMappingURL=register.js.map